import { GridColDef } from '@mui/x-data-grid';
import { ShoppingListItemType } from './components/stock-shopping-list/entity';
import { StockShoppingListActions } from './components/stock-shopping-list/stock-shopping-list-actions';
import { Stack, Typography } from '@mui/material';

export const createShoppingListColumns = (
  formatAmount: (amount: number | string | undefined) => string,
): GridColDef<ShoppingListItemType[][number]>[] => {
  return [
    {
      field: 'item',
      headerName: 'shoppingList.item',
      flex: 3,
      disableColumnMenu: true,
      minWidth: 130,
    },
    {
      field: 'price',
      headerName: 'shoppingList.price',
      disableColumnMenu: true,
      flex: 3,
      display: 'flex',
      minWidth: 80,
      renderCell: params => formatAmount(params.row.price),
    },
    {
      field: 'amount',
      headerName: 'shoppingList.quantity',
      flex: 3,
      minWidth: 90,
      disableColumnMenu: true,
      renderCell: params => (
        <Stack justifyContent="center" sx={{ lineHeight: 1.2 }}>
          <Typography variant="body2">{params.value} ks</Typography>
          <Typography variant="caption" color="text.secondary">
            {params.row.unitAmount} {params.row.unit}
          </Typography>
        </Stack>
      ),
    },
    {
      field: 'edit',
      headerName: '',
      flex: 3,
      width: 20,
      editable: false,
      display: 'flex',
      disableColumnMenu: true,
      renderCell: params => <StockShoppingListActions id={params.row.id} />,
    },
  ];
};
